import { render, staticRenderFns } from "./CustomerSupplierCreate.vue?vue&type=template&id=beaaa9f6&scoped=true&"
import script from "./CustomerSupplierCreate.vue?vue&type=script&lang=js&"
export * from "./CustomerSupplierCreate.vue?vue&type=script&lang=js&"
import style0 from "./CustomerSupplierCreate.vue?vue&type=style&index=0&id=beaaa9f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beaaa9f6",
  null
  
)

export default component.exports